import { Controller } from "@hotwired/stimulus"
import 'emoji-picker-element';

export default class extends Controller {
  static values = { inputSelector: String, displaySelector: String };

  connect() {
    this.display = document.querySelector(this.displaySelectorValue);
    this.input = document.querySelector(this.inputSelectorValue);
  }

  handleEmojiSelect(e) {
    this.display.textContent = e.detail.unicode;
    this.input.value = e.detail.unicode;
  }
}